! function(n) {
	function t(t, c) {
		var S = n.extend({}, n.fn.countdowntimer.defaults, c),
			t = t;
		t.addClass("style");
		var H = "",
			M = "",
			h = "",
			v = "";
		if (H = S.size, M = S.borderColor, h = S.fontColor, v = S.backgroundColor, void 0 != c.regexpMatchFormat && void 0 != c.regexpReplaceWith && void 0 == c.timeSeparator && (window["regexpMatchFormat_" + t.attr("id")] = c.regexpMatchFormat, window["regexpReplaceWith_" + t.attr("id")] = c.regexpReplaceWith), void 0 != c.borderColor || void 0 != c.fontColor || void 0 != c.backgroundColor) {
			var g = {
				background: v,
				color: h,
				"border-color": M
			};
			t.css(g)
		} else t.addClass("colorDefinition");
		if (void 0 != c.size) switch (H) {
			case "xl":
				t.addClass("size_xl");
				break;
			case "lg":
				t.addClass("size_lg");
				break;
			case "md":
				t.addClass("size_md");
				break;
			case "sm":
				t.addClass("size_sm");
				break;
			case "xs":
				t.addClass("size_xs")
		} else "sm" == H && t.addClass("size_sm");
		if (void 0 != c.startDate || void 0 != c.dateAndTime || void 0 != c.currentTime || void 0 == c.hours && void 0 == c.minutes && void 0 == c.seconds)
			if (void 0 != c.startDate && void 0 != c.dateAndTime && void 0 == c.currentTime) {
				startDate = "", endDate = "", timer_startDate = "", window["startDate" + t.attr("id")] = new Date(S.startDate), window["endDate" + t.attr("id")] = new Date(S.dateAndTime);
				var p = "withStart";
				a(t, S, p), window["timer_startDate" + t.attr("id")] = setInterval(function() {
					a(t, S, p)
				}, 1e3 * S.tickInterval)
			} else if (void 0 == c.startDate && void 0 != c.dateAndTime && void 0 == c.currentTime) {
			startTime = "", dateTime = "", timer_givenDate = "";
			var I = S.startDate.getHours() < 10 ? "0" + S.startDate.getHours() : S.startDate.getHours(),
				f = S.startDate.getMinutes() < 10 ? "0" + S.startDate.getMinutes() : S.startDate.getMinutes(),
				k = S.startDate.getSeconds() < 10 ? "0" + S.startDate.getSeconds() : S.startDate.getSeconds(),
				D = S.startDate.getMonth() + 1 < 10 ? "0" + (S.startDate.getMonth() + 1) : S.startDate.getMonth() + 1,
				T = S.startDate.getDate() < 10 ? "0" + S.startDate.getDate() : S.startDate.getDate(),
				x = S.startDate.getFullYear();
			window["startTime" + t.attr("id")] = new Date(x + "/" + D + "/" + T + " " + I + ":" + f + ":" + k), window["dateTime" + t.attr("id")] = new Date(S.dateAndTime);
			var p = "withnoStart";
			a(t, S, p), window["timer_givenDate" + t.attr("id")] = setInterval(function() {
				a(t, S, p)
			}, 1e3 * S.tickInterval)
		} else void 0 != c.currentTime ? (currentTime = "", timer_currentDate = "", window["currentTime" + t.attr("id")] = S.currentTime, _(t, S), window["timer_currentDate" + t.attr("id")] = setInterval(function() {
			_(t, S)
		}, 1e3 * S.tickInterval)) : (countSeconds = "", timer_secondsTimer = "", window["countSeconds" + t.attr("id")] = S.seconds, window["timer_secondsTimer" + t.attr("id")] = setInterval(function() {
			u(t)
		}, 1e3));
		else void 0 != c.hours && void 0 == c.minutes && void 0 == c.seconds ? (hours_H = "", minutes_H = "", seconds_H = "", timer_H = "", window["hours_H" + t.attr("id")] = S.hours, window["minutes_H" + t.attr("id")] = S.minutes, window["seconds_H" + t.attr("id")] = S.seconds, void 0 != c.pauseButton && l(t, "H", S, e), void 0 != c.stopButton && m(t, "H", S, e), e(t, S), window["timer_H" + t.attr("id")] = setInterval(function() {
			e(t, S)
		}, 1e3 * S.tickInterval)) : void 0 == c.hours && void 0 != c.minutes && void 0 == c.seconds ? (hours_M = "", minutes_M = "", seconds_M = "", timer_M = "", window["hours_M" + t.attr("id")] = S.hours, window["minutes_M" + t.attr("id")] = S.minutes, window["seconds_M" + t.attr("id")] = S.seconds, void 0 != c.pauseButton && l(t, "M", S, o), void 0 != c.stopButton && m(t, "M", S, o), o(t, S), window["timer_M" + t.attr("id")] = setInterval(function() {
			o(t, S)
		}, 1e3 * S.tickInterval)) : void 0 == c.hours && void 0 == c.minutes && void 0 != c.seconds ? (hours_S = "", minutes_S = "", seconds_S = "", timer_S = "", window["hours_S" + t.attr("id")] = S.hours, window["minutes_S" + t.attr("id")] = S.minutes, window["seconds_S" + t.attr("id")] = S.seconds, void 0 != c.pauseButton && l(t, "S", S, i), void 0 != c.stopButton && m(t, "S", S, i), i(t, S), window["timer_S" + t.attr("id")] = setInterval(function() {
			i(t, S)
		}, 1e3 * S.tickInterval)) : void 0 != c.hours && void 0 != c.minutes && void 0 == c.seconds ? (hours_HM = "", minutes_HM = "", seconds_HM = "", timer_HM = "", window["hours_HM" + t.attr("id")] = S.hours, window["minutes_HM" + t.attr("id")] = S.minutes, window["seconds_HM" + t.attr("id")] = S.seconds, void 0 != c.pauseButton && l(t, "HM", S, w), void 0 != c.stopButton && m(t, "HM", S, w), w(t, S), window["timer_HM" + t.attr("id")] = setInterval(function() {
			w(t, S)
		}, 1e3 * S.tickInterval)) : void 0 == c.hours && void 0 != c.minutes && void 0 != c.seconds ? (hours_MS = "", minutes_MS = "", seconds_MS = "", timer_MS = "", window["hours_MS" + t.attr("id")] = S.hours, window["minutes_MS" + t.attr("id")] = S.minutes, window["seconds_MS" + t.attr("id")] = S.seconds, void 0 != c.pauseButton && l(t, "MS", S, d), void 0 != c.stopButton && m(t, "MS", S, d), d(t, S), window["timer_MS" + t.attr("id")] = setInterval(function() {
			d(t, S)
		}, 1e3 * S.tickInterval)) : void 0 != c.hours && void 0 == c.minutes && void 0 != c.seconds ? (hours_HS = "", minutes_HS = "", seconds_HS = "", timer_HS = "", window["hours_HS" + t.attr("id")] = S.hours, window["minutes_HS" + t.attr("id")] = S.minutes, window["seconds_HS" + t.attr("id")] = S.seconds, void 0 != c.pauseButton && l(t, "HS", S, s), void 0 != c.stopButton && m(t, "HS", S, s), s(t, S), window["timer_HS" + t.attr("id")] = setInterval(function() {
			s(t, S)
		}, 1e3 * S.tickInterval)) : void 0 != c.hours && void 0 != c.minutes && void 0 != c.seconds && (hours_HMS = "", minutes_HMS = "", seconds_HMS = "", timer_HMS = "", window["hours_HMS" + t.attr("id")] = S.hours, window["minutes_HMS" + t.attr("id")] = S.minutes, window["seconds_HMS" + t.attr("id")] = S.seconds, void 0 != c.pauseButton && l(t, "HMS", S, r), void 0 != c.stopButton && m(t, "HMS", S, r), r(t, S), window["timer_HMS" + t.attr("id")] = setInterval(function() {
			r(t, S)
		}, 1e3 * S.tickInterval))
	}

	function e(n, t) {
		var e = n.attr("id");
		window["minutes_H" + e] == t.minutes && window["seconds_H" + e] == t.seconds && window["hours_H" + e] == t.hours ? (window["hours_H" + e].toString().length < 2 && (window["hours_H" + e] = "0" + window["hours_H" + e]), S(n, window["hours_H" + e] + t.timeSeparator + "00" + t.timeSeparator + "00"), window["seconds_H" + e] = 60 - t.tickInterval, window["minutes_H" + e] = 59, 0 != window["hours_H" + e] ? window["hours_H" + e]-- : (delete window["hours_H" + e], delete window["minutes_H" + e], delete window["seconds_H" + e], clearInterval(window["timer_H" + e]), c(n, t))) : (window["hours_H" + e].toString().length < 2 && (window["hours_H" + e] = "0" + window["hours_H" + e]), window["minutes_H" + e].toString().length < 2 && (window["minutes_H" + e] = "0" + window["minutes_H" + e]), window["seconds_H" + e].toString().length < 2 && (window["seconds_H" + e] = "0" + window["seconds_H" + e]), S(n, window["hours_H" + e] + t.timeSeparator + window["minutes_H" + e] + t.timeSeparator + window["seconds_H" + e]), window["seconds_H" + e] -= t.tickInterval, 0 != window["minutes_H" + e] && window["seconds_H" + e] < 0 && (window["minutes_H" + e]--, window["seconds_H" + e] = 60 - t.tickInterval), 0 == window["minutes_H" + e] && window["seconds_H" + e] < 0 && 0 != window["hours_H" + e] && (window["hours_H" + e]--, window["minutes_H" + e] = 59, window["seconds_H" + e] = 60 - t.tickInterval), 0 == window["minutes_H" + e] && window["seconds_H" + e] < 0 && 0 == window["hours_H" + e] && (delete window["hours_H" + e], delete window["minutes_H" + e], delete window["seconds_H" + e], clearInterval(window["timer_H" + e]), c(n, t))), e = null
	}

	function o(n, t) {
		var e = n.attr("id");
		window["minutes_M" + e] == t.minutes && window["seconds_M" + e] == t.seconds ? (window["minutes_M" + e].toString().length < 2 && (window["minutes_M" + e] = "0" + window["minutes_M" + e]), S(n, window["minutes_M" + e] + t.timeSeparator + "00"), window["seconds_M" + e] = 60 - t.tickInterval, 0 != window["minutes_M" + e] ? window["minutes_M" + e]-- : (delete window["hours_M" + e], delete window["minutes_M" + e], delete window["seconds_M" + e], clearInterval(window["timer_M" + e]), c(n, t))) : (window["minutes_M" + e].toString().length < 2 && (window["minutes_M" + e] = "0" + window["minutes_M" + e]), window["seconds_M" + e].toString().length < 2 && (window["seconds_M" + e] = "0" + window["seconds_M" + e]), S(n, window["minutes_M" + e] + t.timeSeparator + window["seconds_M" + e]), window["seconds_M" + e] -= t.tickInterval, 0 != window["minutes_M" + e] && window["seconds_M" + e] < 0 && (window["minutes_M" + e]--, window["seconds_M" + e] = 60 - t.tickInterval), 0 == window["minutes_M" + e] && window["seconds_M" + e] < 0 && (delete window["hours_M" + e], delete window["minutes_M" + e], delete window["seconds_M" + e], clearInterval(window["timer_M" + e]), c(n, t))), e = null
	}

	function i(n, t) {
		var e = n.attr("id");
		window["seconds_S" + e].toString().length < 2 && (window["seconds_S" + e] = "0" + window["seconds_S" + e]), S(n, window["seconds_S" + e] + " sec"), window["seconds_S" + e] -= t.tickInterval, window["seconds_S" + e] < 0 && (delete window["hours_S" + e], delete window["minutes_S" + e], delete window["seconds_S" + e], clearInterval(window["timer_S" + e]), c(n, t)), e = null
	}

	function w(n, t) {
		var e = n.attr("id");
		window["minutes_HM" + e] == t.minutes && window["hours_HM" + e] == t.hours ? (window["hours_HM" + e].toString().length < 2 && (window["hours_HM" + e] = "0" + window["hours_HM" + e]), window["minutes_HM" + e].toString().length < 2 && (window["minutes_HM" + e] = "0" + window["minutes_HM" + e]), S(n, window["hours_HM" + e] + t.timeSeparator + window["minutes_HM" + e] + t.timeSeparator + "00"), 0 != window["hours_HM" + e] && 0 == window["minutes_HM" + e] ? (window["hours_HM" + e]--, window["minutes_HM" + e] = 59, window["seconds_HM" + e] = 60 - t.tickInterval) : 0 == window["hours_HM" + e] && 0 != window["minutes_HM" + e] ? (window["seconds_HM" + e] = 60 - t.tickInterval, window["minutes_HM" + e]--) : (window["seconds_HM" + e] = 60 - t.tickInterval, window["minutes_HM" + e]--), 0 == window["hours_HM" + e] && 0 == window["minutes_HM" + e] && 60 == window["seconds_HM" + e] && (delete window["hours_HM" + e], delete window["minutes_HM" + e], delete window["seconds_HM" + e], clearInterval(window["timer_HM" + e]), c(n, t))) : (window["hours_HM" + e].toString().length < 2 && (window["hours_HM" + e] = "0" + window["hours_HM" + e]), window["minutes_HM" + e].toString().length < 2 && (window["minutes_HM" + e] = "0" + window["minutes_HM" + e]), window["seconds_HM" + e].toString().length < 2 && (window["seconds_HM" + e] = "0" + window["seconds_HM" + e]), S(n, window["hours_HM" + e] + t.timeSeparator + window["minutes_HM" + e] + t.timeSeparator + window["seconds_HM" + e]), window["seconds_HM" + e] -= t.tickInterval, 0 != window["minutes_HM" + e] && window["seconds_HM" + e] < 0 && (window["minutes_HM" + e]--, window["seconds_HM" + e] = 60 - t.tickInterval), 0 == window["minutes_HM" + e] && window["seconds_HM" + e] < 0 && 0 != window["hours_HM" + e] && (window["hours_HM" + e]--, window["minutes_HM" + e] = 59, window["seconds_HM" + e] = 60 - t.tickInterval), 0 == window["minutes_HM" + e] && window["seconds_HM" + e] < 0 && 0 == window["hours_HM" + e] && (delete window["hours_HM" + e], delete window["minutes_HM" + e], delete window["seconds_HM" + e], clearInterval(window["timer_HM" + e]), c(n, t))), e = null
	}

	function d(n, t) {
		var e = n.attr("id");
		window["minutes_MS" + e] == t.minutes && window["seconds_MS" + e] == t.seconds ? (window["minutes_MS" + e].toString().length < 2 && (window["minutes_MS" + e] = "0" + window["minutes_MS" + e]), window["seconds_MS" + e].toString().length < 2 && (window["seconds_MS" + e] = "0" + window["seconds_MS" + e]), S(n, window["minutes_MS" + e] + t.timeSeparator + window["seconds_MS" + e]), 0 != window["minutes_MS" + e] && 0 == window["seconds_MS" + e] ? (window["minutes_MS" + e]--, window["seconds_MS" + e] = 60 - t.tickInterval) : 0 == window["minutes_MS" + e] && 0 == window["seconds_MS" + e] ? (delete window["hours_MS" + e], delete window["minutes_MS" + e], delete window["seconds_MS" + e], clearInterval(window["timer_MS" + e]), c(n, t)) : window["seconds_MS" + e] -= t.tickInterval) : (window["minutes_MS" + e].toString().length < 2 && (window["minutes_MS" + e] = "0" + window["minutes_MS" + e]), window["seconds_MS" + e].toString().length < 2 && (window["seconds_MS" + e] = "0" + window["seconds_MS" + e]), S(n, window["minutes_MS" + e] + t.timeSeparator + window["seconds_MS" + e]), window["seconds_MS" + e] -= t.tickInterval, 0 != window["minutes_MS" + e] && window["seconds_MS" + e] < 0 && (window["minutes_MS" + e]--, window["seconds_MS" + e] = 60 - t.tickInterval), 0 == window["minutes_MS" + e] && window["seconds_MS" + e] < 0 && (delete window["hours_MS" + e], delete window["minutes_MS" + e], delete window["seconds_MS" + e], clearInterval(window["timer_MS" + e]), c(n, t))), e = null
	}

	function s(n, t) {
		var e = n.attr("id");
		window["seconds_HS" + e] == t.seconds && window["hours_HS" + e] == t.hours ? (window["hours_HS" + e].toString().length < 2 && (window["hours_HS" + e] = "0" + window["hours_HS" + e]), window["seconds_HS" + e].toString().length < 2 && (window["seconds_HS" + e] = "0" + window["seconds_HS" + e]), S(n, window["hours_HS" + e] + t.timeSeparator + "00" + t.timeSeparator + window["seconds_HS" + e]), 0 == window["hours_HS" + e] && 0 == window["seconds_HS" + e] ? (delete window["hours_HS" + e], delete window["minutes_HS" + e], delete window["seconds_HS" + e], clearInterval(window["timer_HS" + e]), c(n, t)) : 0 != window["hours_HS" + e] && 0 == window["seconds_HS" + e] ? (window["hours_HS" + e]--, window["minutes_HS" + e] = 59, window["seconds_HS" + e] = 60 - t.tickInterval) : window["seconds_HS" + e] -= t.tickInterval) : (window["hours_HS" + e].toString().length < 2 && (window["hours_HS" + e] = "0" + window["hours_HS" + e]), window["minutes_HS" + e].toString().length < 2 && (window["minutes_HS" + e] = "0" + window["minutes_HS" + e]), window["seconds_HS" + e].toString().length < 2 && (window["seconds_HS" + e] = "0" + window["seconds_HS" + e]), S(n, window["hours_HS" + e] + t.timeSeparator + window["minutes_HS" + e] + t.timeSeparator + window["seconds_HS" + e]), window["seconds_HS" + e] -= t.tickInterval, 0 != window["minutes_HS" + e] && window["seconds_HS" + e] < 0 && (window["minutes_HS" + e]--, window["seconds_HS" + e] = 60 - t.tickInterval), 0 == window["minutes_HS" + e] && window["seconds_HS" + e] < 0 && 0 != window["hours_HS" + e] && (window["hours_HS" + e]--, window["minutes_HS" + e] = 59, window["seconds_HS" + e] = 60 - t.tickInterval), 0 == window["minutes_HS" + e] && window["seconds_HS" + e] < 0 && 0 == window["hours_HS" + e] && (delete window["hours_HS" + e], delete window["minutes_HS" + e], delete window["seconds_HS" + e], clearInterval(window["timer_HS" + e]), c(n, t))), e = null
	}

	function r(n, t) {
		var e = n.attr("id"),
			o = "";
		window["hours_HMS" + e] > 0 && (o = "<samp>" + window["hours_HMS" + e] + "</samp><span> hours </span>"), window["minutes_HMS" + e] == t.minutes && window["seconds_HMS" + e] == t.seconds && window["hours_HMS" + e] == t.hours ? (window["hours_HMS" + e].toString().length < 2 && (window["hours_HMS" + e] = "0" + window["hours_HMS" + e]), window["minutes_HMS" + e].toString().length < 2 && (window["minutes_HMS" + e] = "0" + window["minutes_HMS" + e]), window["seconds_HMS" + e].toString().length < 2 && (window["seconds_HMS" + e] = "0" + window["seconds_HMS" + e]), S(n, o + "<samp>" + window["minutes_HMS" + e] + "</samp><span> minutes </span>"), 0 == window["hours_HMS" + e] && 0 == window["minutes_HMS" + e] && 0 == window["seconds_HMS" + e] ? (delete window["hours_HMS" + e], delete window["minutes_HMS" + e], delete window["seconds_HMS" + e], clearInterval(window["timer_HMS" + e]), c(n, t)) : 0 != window["hours_HMS" + e] && 0 == window["minutes_HMS" + e] && 0 == window["seconds_HMS" + e] ? (window["hours_HMS" + e]--, window["minutes_HMS" + e] = 59, window["seconds_HMS" + e] = 60 - t.tickInterval) : 0 == window["hours_HMS" + e] && 0 != window["minutes_HMS" + e] && 0 == window["seconds_HMS" + e] ? (window["minutes_HMS" + e]--, window["seconds_HMS" + e] = 60 - t.tickInterval) : 0 != window["hours_HMS" + e] && 0 != window["minutes_HMS" + e] && 0 == window["seconds_HMS" + e] ? (window["minutes_HMS" + e]--, window["seconds_HMS" + e] = 60 - t.tickInterval) : window["seconds_HMS" + e] -= t.tickInterval) : (window["hours_HMS" + e].toString().length < 2 && (window["hours_HMS" + e] = "0" + window["hours_HMS" + e]), window["minutes_HMS" + e].toString().length < 2 && (window["minutes_HMS" + e] = "0" + window["minutes_HMS" + e]), window["seconds_HMS" + e].toString().length < 2 && (window["seconds_HMS" + e] = "0" + window["seconds_HMS" + e]), S(n, o + "<samp>" + window["minutes_HMS" + e] + "</samp><span> minutes </span>"), window["seconds_HMS" + e] -= t.tickInterval, 0 != window["minutes_HMS" + e] && window["seconds_HMS" + e] < 0 && (window["minutes_HMS" + e]--, window["seconds_HMS" + e] = 60 - t.tickInterval), 0 == window["minutes_HMS" + e] && window["seconds_HMS" + e] < 0 && 0 != window["hours_HMS" + e] && (window["hours_HMS" + e]--, window["minutes_HMS" + e] = 59, window["seconds_HMS" + e] = 60 - t.tickInterval), 0 == window["minutes_HMS" + e] && window["seconds_HMS" + e] < 0 && 0 == window["hours_HMS" + e] && (delete window["hours_HMS" + e], delete window["minutes_HMS" + e], delete window["seconds_HMS" + e], clearInterval(window["timer_HMS" + e]), c(n, t))), e = null
	}

	function a(n, t, e) {
		var o = n.attr("id"),
			i = "withnoStart" == e ? window["dateTime" + o] : window["endDate" + o],
			w = "withnoStart" == e ? window["startTime" + o] : window["startDate" + o],
			d = Math.floor((i - w) / 864e5),
			s = Math.floor((i - w) % 864e5 / 36e5),
			r = Math.floor((i - w) % 864e5 / 6e4) % 60,
			a = Math.floor((i - w) % 864e5 / 1e3) % 60 % 60;
		i - w > 0 ? (d.toString().length < 2 && (d = "0" + d), s.toString().length < 2 && (s = "0" + s), r.toString().length < 2 && (r = "0" + r), a.toString().length < 2 && (a = "0" + a), S(n, d + t.timeSeparator + s + t.timeSeparator + r + t.timeSeparator + a), "withnoStart" == e ? window["startTime" + o].setSeconds(window["startTime" + o].getSeconds() + t.tickInterval) : window["startDate" + o].setSeconds(window["startDate" + o].getSeconds() + t.tickInterval)) : (S(n, "00" + t.timeSeparator + "00" + t.timeSeparator + "00" + t.timeSeparator + "00"), "withnoStart" == e ? (delete window["dateTime" + o], delete window["startTime" + o], clearInterval(window["timer_givenDate" + o])) : "withStart" == e && (delete window["startDate" + o], delete window["endDate" + o], clearInterval(window["timer_startDate" + o])), c(n, t)), o = null
	}

	function _(n, t) {
		if (1 == window["currentTime" + n.attr("id")]) {
			var e = new Date,
				o = e.getHours(),
				i = e.getMinutes(),
				w = e.getSeconds();
			o.toString().length < 2 && (o = "0" + o), i.toString().length < 2 && (i = "0" + i), w.toString().length < 2 && (w = "0" + w), S(n, o + t.timeSeparator + i + t.timeSeparator + w)
		} else alert("Set Current Time option.")
	}

	function u(n) {
		var t = n.attr("id");
		window["countSeconds" + t].toString().length < 2 && (window["countSeconds" + t] = "0" + window["countSeconds" + t]), S(n, window["countSeconds" + t] + " sec"), window["countSeconds" + t]--, -1 == window["countSeconds" + t] && (delete window["countSeconds" + t], clearInterval(window["timer_secondsTimer" + t])), t = null
	}

	function c(t, e) {
		null != e.timeUp && 1 == n.isFunction(e.timeUp) && e.timeUp.apply(t, []), null != e.expiryUrl && (window.location = e.expiryUrl)
	}

	function S(n, t) {
		var e = t;
		if ("undefined" != typeof window["regexpMatchFormat_" + n.attr("id")] && "undefined" != typeof window["regexpReplaceWith_" + n.attr("id")]) {
			var o = new RegExp(window["regexpMatchFormat_" + n.attr("id")]);
			e = t.replace(o, window["regexpReplaceWith_" + n.attr("id")])
		}
		n.html(e)
	}

	function l(t, e, o, i) {
		n("#" + o.pauseButton).click(function() {
			"resume" != n(this).val() ? (n("#" + o.pauseButton).val("resume").text("Resume"), clearInterval(window["timer_" + e + t.attr("id")])) : "resume" == n(this).val() && (n("#" + o.pauseButton).val("pause").text("Pause"), window["timer_" + e + t.attr("id")] = setInterval(function() {
				i(t, o)
			}, 1e3 * o.tickInterval))
		})
	}

	function m(t, e, o, i) {
		n("#" + o.stopButton).click(function() {
			"start" != n(this).val() ? (n("#" + o.stopButton).val("start").text("Start"), clearInterval(window["timer_" + e + t.attr("id")]), window["hours_" + e + t.attr("id")] = o.hours, window["minutes_" + e + t.attr("id")] = o.minutes, window["seconds_" + e + t.attr("id")] = o.seconds, i(t, o)) : "start" == n(this).val() && (n("#" + o.stopButton).val("stop").text("Stop"), window["timer_" + e + t.attr("id")] = setInterval(function() {
				i(t, o)
			}, 1e3 * o.tickInterval))
		})
	}
	n.fn.countdowntimer = function(e) {
		return this.each(function() {
			t(n(this), e)
		})
	}, n.fn.countdowntimer.defaults = {
		hours: 0,
		minutes: 0,
		seconds: 60,
		startDate: new Date,
		dateAndTime: new Date("0000/00/00 00:00:00"),
		currentTime: !1,
		size: "sm",
		borderColor: "#F0068E",
		fontColor: "#FFFFFF",
		backgroundColor: "#000000",
		timeSeparator: "<span>:</span>",
		tickInterval: 1,
		timeUp: null,
		expiryUrl: null,
		regexpMatchFormat: null,
		regexpReplaceWith: null,
		pauseButton: null,
		stopButton: null
	}
}(jQuery);

if ("undefined" == typeof jQuery) throw new Error("Bootstrap's JavaScript requires jQuery"); + function(a) {
	"use strict";
	var b = a.fn.jquery.split(" ")[0].split(".");
	if (b[0] < 2 && b[1] < 9 || 1 == b[0] && 9 == b[1] && b[2] < 1) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher")
}(jQuery), + function(a) {
	"use strict";

	function b() {
		var a = document.createElement("bootstrap"),
			b = {
				WebkitTransition: "webkitTransitionEnd",
				MozTransition: "transitionend",
				OTransition: "oTransitionEnd otransitionend",
				transition: "transitionend"
			};
		for (var c in b)
			if (void 0 !== a.style[c]) return {
				end: b[c]
			};
		return !1
	}
	a.fn.emulateTransitionEnd = function(b) {
		var c = !1,
			d = this;
		a(this).one("bsTransitionEnd", function() {
			c = !0
		});
		var e = function() {
			c || a(d).trigger(a.support.transition.end)
		};
		return setTimeout(e, b), this
	}, a(function() {
		a.support.transition = b(), a.support.transition && (a.event.special.bsTransitionEnd = {
			bindType: a.support.transition.end,
			delegateType: a.support.transition.end,
			handle: function(b) {
				return a(b.target).is(this) ? b.handleObj.handler.apply(this, arguments) : void 0
			}
		})
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var c = a(this),
				e = c.data("bs.alert");
			e || c.data("bs.alert", e = new d(this)), "string" == typeof b && e[b].call(c)
		})
	}
	var c = '[data-dismiss="alert"]',
		d = function(b) {
			a(b).on("click", c, this.close)
		};
	d.VERSION = "3.3.2", d.TRANSITION_DURATION = 150, d.prototype.close = function(b) {
		function c() {
			g.detach().trigger("closed.bs.alert").remove()
		}
		var e = a(this),
			f = e.attr("data-target");
		f || (f = e.attr("href"), f = f && f.replace(/.*(?=#[^\s]*$)/, ""));
		var g = a(f);
		b && b.preventDefault(), g.length || (g = e.closest(".alert")), g.trigger(b = a.Event("close.bs.alert")), b.isDefaultPrevented() || (g.removeClass("in"), a.support.transition && g.hasClass("fade") ? g.one("bsTransitionEnd", c).emulateTransitionEnd(d.TRANSITION_DURATION) : c())
	};
	var e = a.fn.alert;
	a.fn.alert = b, a.fn.alert.Constructor = d, a.fn.alert.noConflict = function() {
		return a.fn.alert = e, this
	}, a(document).on("click.bs.alert.data-api", c, d.prototype.close)
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.button"),
				f = "object" == typeof b && b;
			e || d.data("bs.button", e = new c(this, f)), "toggle" == b ? e.toggle() : b && e.setState(b)
		})
	}
	var c = function(b, d) {
		this.$element = a(b), this.options = a.extend({}, c.DEFAULTS, d), this.isLoading = !1
	};
	c.VERSION = "3.3.2", c.DEFAULTS = {
		loadingText: "loading..."
	}, c.prototype.setState = function(b) {
		var c = "disabled",
			d = this.$element,
			e = d.is("input") ? "val" : "html",
			f = d.data();
		b += "Text", null == f.resetText && d.data("resetText", d[e]()), setTimeout(a.proxy(function() {
			d[e](null == f[b] ? this.options[b] : f[b]), "loadingText" == b ? (this.isLoading = !0, d.addClass(c).attr(c, c)) : this.isLoading && (this.isLoading = !1, d.removeClass(c).removeAttr(c))
		}, this), 0)
	}, c.prototype.toggle = function() {
		var a = !0,
			b = this.$element.closest('[data-toggle="buttons"]');
		if (b.length) {
			var c = this.$element.find("input");
			"radio" == c.prop("type") && (c.prop("checked") && this.$element.hasClass("active") ? a = !1 : b.find(".active").removeClass("active")), a && c.prop("checked", !this.$element.hasClass("active")).trigger("change")
		} else this.$element.attr("aria-pressed", !this.$element.hasClass("active"));
		a && this.$element.toggleClass("active")
	};
	var d = a.fn.button;
	a.fn.button = b, a.fn.button.Constructor = c, a.fn.button.noConflict = function() {
		return a.fn.button = d, this
	}, a(document).on("click.bs.button.data-api", '[data-toggle^="button"]', function(c) {
		var d = a(c.target);
		d.hasClass("btn") || (d = d.closest(".btn")), b.call(d, "toggle"), c.preventDefault()
	}).on("focus.bs.button.data-api blur.bs.button.data-api", '[data-toggle^="button"]', function(b) {
		a(b.target).closest(".btn").toggleClass("focus", /^focus(in)?$/.test(b.type))
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.carousel"),
				f = a.extend({}, c.DEFAULTS, d.data(), "object" == typeof b && b),
				g = "string" == typeof b ? b : f.slide;
			e || d.data("bs.carousel", e = new c(this, f)), "number" == typeof b ? e.to(b) : g ? e[g]() : f.interval && e.pause().cycle()
		})
	}
	var c = function(b, c) {
		this.$element = a(b), this.$indicators = this.$element.find(".carousel-indicators"), this.options = c, this.paused = this.sliding = this.interval = this.$active = this.$items = null, this.options.keyboard && this.$element.on("keydown.bs.carousel", a.proxy(this.keydown, this)), "hover" == this.options.pause && !("ontouchstart" in document.documentElement) && this.$element.on("mouseenter.bs.carousel", a.proxy(this.pause, this)).on("mouseleave.bs.carousel", a.proxy(this.cycle, this))
	};
	c.VERSION = "3.3.2", c.TRANSITION_DURATION = 600, c.DEFAULTS = {
		interval: 5e3,
		pause: "hover",
		wrap: !0,
		keyboard: !0
	}, c.prototype.keydown = function(a) {
		if (!/input|textarea/i.test(a.target.tagName)) {
			switch (a.which) {
				case 37:
					this.prev();
					break;
				case 39:
					this.next();
					break;
				default:
					return
			}
			a.preventDefault()
		}
	}, c.prototype.cycle = function(b) {
		return b || (this.paused = !1), this.interval && clearInterval(this.interval), this.options.interval && !this.paused && (this.interval = setInterval(a.proxy(this.next, this), this.options.interval)), this
	}, c.prototype.getItemIndex = function(a) {
		return this.$items = a.parent().children(".item"), this.$items.index(a || this.$active)
	}, c.prototype.getItemForDirection = function(a, b) {
		var c = this.getItemIndex(b),
			d = "prev" == a && 0 === c || "next" == a && c == this.$items.length - 1;
		if (d && !this.options.wrap) return b;
		var e = "prev" == a ? -1 : 1,
			f = (c + e) % this.$items.length;
		return this.$items.eq(f)
	}, c.prototype.to = function(a) {
		var b = this,
			c = this.getItemIndex(this.$active = this.$element.find(".item.active"));
		return a > this.$items.length - 1 || 0 > a ? void 0 : this.sliding ? this.$element.one("slid.bs.carousel", function() {
			b.to(a)
		}) : c == a ? this.pause().cycle() : this.slide(a > c ? "next" : "prev", this.$items.eq(a))
	}, c.prototype.pause = function(b) {
		return b || (this.paused = !0), this.$element.find(".next, .prev").length && a.support.transition && (this.$element.trigger(a.support.transition.end), this.cycle(!0)), this.interval = clearInterval(this.interval), this
	}, c.prototype.next = function() {
		return this.sliding ? void 0 : this.slide("next")
	}, c.prototype.prev = function() {
		return this.sliding ? void 0 : this.slide("prev")
	}, c.prototype.slide = function(b, d) {
		var e = this.$element.find(".item.active"),
			f = d || this.getItemForDirection(b, e),
			g = this.interval,
			h = "next" == b ? "left" : "right",
			i = this;
		if (f.hasClass("active")) return this.sliding = !1;
		var j = f[0],
			k = a.Event("slide.bs.carousel", {
				relatedTarget: j,
				direction: h
			});
		if (this.$element.trigger(k), !k.isDefaultPrevented()) {
			if (this.sliding = !0, g && this.pause(), this.$indicators.length) {
				this.$indicators.find(".active").removeClass("active");
				var l = a(this.$indicators.children()[this.getItemIndex(f)]);
				l && l.addClass("active")
			}
			var m = a.Event("slid.bs.carousel", {
				relatedTarget: j,
				direction: h
			});
			return a.support.transition && this.$element.hasClass("slide") ? (f.addClass(b), f[0].offsetWidth, e.addClass(h), f.addClass(h), e.one("bsTransitionEnd", function() {
				f.removeClass([b, h].join(" ")).addClass("active"), e.removeClass(["active", h].join(" ")), i.sliding = !1, setTimeout(function() {
					i.$element.trigger(m)
				}, 0)
			}).emulateTransitionEnd(c.TRANSITION_DURATION)) : (e.removeClass("active"), f.addClass("active"), this.sliding = !1, this.$element.trigger(m)), g && this.cycle(), this
		}
	};
	var d = a.fn.carousel;
	a.fn.carousel = b, a.fn.carousel.Constructor = c, a.fn.carousel.noConflict = function() {
		return a.fn.carousel = d, this
	};
	var e = function(c) {
		var d, e = a(this),
			f = a(e.attr("data-target") || (d = e.attr("href")) && d.replace(/.*(?=#[^\s]+$)/, ""));
		if (f.hasClass("carousel")) {
			var g = a.extend({}, f.data(), e.data()),
				h = e.attr("data-slide-to");
			h && (g.interval = !1), b.call(f, g), h && f.data("bs.carousel").to(h), c.preventDefault()
		}
	};
	a(document).on("click.bs.carousel.data-api", "[data-slide]", e).on("click.bs.carousel.data-api", "[data-slide-to]", e), a(window).on("load", function() {
		a('[data-ride="carousel"]').each(function() {
			var c = a(this);
			b.call(c, c.data())
		})
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		var c, d = b.attr("data-target") || (c = b.attr("href")) && c.replace(/.*(?=#[^\s]+$)/, "");
		return a(d)
	}

	function c(b) {
		return this.each(function() {
			var c = a(this),
				e = c.data("bs.collapse"),
				f = a.extend({}, d.DEFAULTS, c.data(), "object" == typeof b && b);
			!e && f.toggle && "show" == b && (f.toggle = !1), e || c.data("bs.collapse", e = new d(this, f)), "string" == typeof b && e[b]()
		})
	}
	var d = function(b, c) {
		this.$element = a(b), this.options = a.extend({}, d.DEFAULTS, c), this.$trigger = a(this.options.trigger).filter('[href="#' + b.id + '"], [data-target="#' + b.id + '"]'), this.transitioning = null, this.options.parent ? this.$parent = this.getParent() : this.addAriaAndCollapsedClass(this.$element, this.$trigger), this.options.toggle && this.toggle()
	};
	d.VERSION = "3.3.2", d.TRANSITION_DURATION = 350, d.DEFAULTS = {
		toggle: !0,
		trigger: '[data-toggle="collapse"]'
	}, d.prototype.dimension = function() {
		var a = this.$element.hasClass("width");
		return a ? "width" : "height"
	}, d.prototype.show = function() {
		if (!this.transitioning && !this.$element.hasClass("in")) {
			var b, e = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");
			if (!(e && e.length && (b = e.data("bs.collapse"), b && b.transitioning))) {
				var f = a.Event("show.bs.collapse");
				if (this.$element.trigger(f), !f.isDefaultPrevented()) {
					e && e.length && (c.call(e, "hide"), b || e.data("bs.collapse", null));
					var g = this.dimension();
					this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded", !0), this.$trigger.removeClass("collapsed").attr("aria-expanded", !0), this.transitioning = 1;
					var h = function() {
						this.$element.removeClass("collapsing").addClass("collapse in")[g](""), this.transitioning = 0, this.$element.trigger("shown.bs.collapse")
					};
					if (!a.support.transition) return h.call(this);
					var i = a.camelCase(["scroll", g].join("-"));
					this.$element.one("bsTransitionEnd", a.proxy(h, this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])
				}
			}
		}
	}, d.prototype.hide = function() {
		if (!this.transitioning && this.$element.hasClass("in")) {
			var b = a.Event("hide.bs.collapse");
			if (this.$element.trigger(b), !b.isDefaultPrevented()) {
				var c = this.dimension();
				this.$element[c](this.$element[c]())[0].offsetHeight, this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded", !1), this.$trigger.addClass("collapsed").attr("aria-expanded", !1), this.transitioning = 1;
				var e = function() {
					this.transitioning = 0, this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")
				};
				return a.support.transition ? void this.$element[c](0).one("bsTransitionEnd", a.proxy(e, this)).emulateTransitionEnd(d.TRANSITION_DURATION) : e.call(this)
			}
		}
	}, d.prototype.toggle = function() {
		this[this.$element.hasClass("in") ? "hide" : "show"]()
	}, d.prototype.getParent = function() {
		return a(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each(a.proxy(function(c, d) {
			var e = a(d);
			this.addAriaAndCollapsedClass(b(e), e)
		}, this)).end()
	}, d.prototype.addAriaAndCollapsedClass = function(a, b) {
		var c = a.hasClass("in");
		a.attr("aria-expanded", c), b.toggleClass("collapsed", !c).attr("aria-expanded", c)
	};
	var e = a.fn.collapse;
	a.fn.collapse = c, a.fn.collapse.Constructor = d, a.fn.collapse.noConflict = function() {
		return a.fn.collapse = e, this
	}, a(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function(d) {
		var e = a(this);
		e.attr("data-target") || d.preventDefault();
		var f = b(e),
			g = f.data("bs.collapse"),
			h = g ? "toggle" : a.extend({}, e.data(), {
				trigger: this
			});
		c.call(f, h)
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		b && 3 === b.which || (a(e).remove(), a(f).each(function() {
			var d = a(this),
				e = c(d),
				f = {
					relatedTarget: this
				};
			e.hasClass("open") && (e.trigger(b = a.Event("hide.bs.dropdown", f)), b.isDefaultPrevented() || (d.attr("aria-expanded", "false"), e.removeClass("open").trigger("hidden.bs.dropdown", f)))
		}))
	}

	function c(b) {
		var c = b.attr("data-target");
		c || (c = b.attr("href"), c = c && /#[A-Za-z]/.test(c) && c.replace(/.*(?=#[^\s]*$)/, ""));
		var d = c && a(c);
		return d && d.length ? d : b.parent()
	}

	function d(b) {
		return this.each(function() {
			var c = a(this),
				d = c.data("bs.dropdown");
			d || c.data("bs.dropdown", d = new g(this)), "string" == typeof b && d[b].call(c)
		})
	}
	var e = ".dropdown-backdrop",
		f = '[data-toggle="dropdown"]',
		g = function(b) {
			a(b).on("click.bs.dropdown", this.toggle)
		};
	g.VERSION = "3.3.2", g.prototype.toggle = function(d) {
		var e = a(this);
		if (!e.is(".disabled, :disabled")) {
			var f = c(e),
				g = f.hasClass("open");
			if (b(), !g) {
				"ontouchstart" in document.documentElement && !f.closest(".navbar-nav").length && a('<div class="dropdown-backdrop"/>').insertAfter(a(this)).on("click", b);
				var h = {
					relatedTarget: this
				};
				if (f.trigger(d = a.Event("show.bs.dropdown", h)), d.isDefaultPrevented()) return;
				e.trigger("focus").attr("aria-expanded", "true"), f.toggleClass("open").trigger("shown.bs.dropdown", h)
			}
			return !1
		}
	}, g.prototype.keydown = function(b) {
		if (/(38|40|27|32)/.test(b.which) && !/input|textarea/i.test(b.target.tagName)) {
			var d = a(this);
			if (b.preventDefault(), b.stopPropagation(), !d.is(".disabled, :disabled")) {
				var e = c(d),
					g = e.hasClass("open");
				if (!g && 27 != b.which || g && 27 == b.which) return 27 == b.which && e.find(f).trigger("focus"), d.trigger("click");
				var h = " li:not(.divider):visible a",
					i = e.find('[role="menu"]' + h + ', [role="listbox"]' + h);
				if (i.length) {
					var j = i.index(b.target);
					38 == b.which && j > 0 && j--, 40 == b.which && j < i.length - 1 && j++, ~j || (j = 0), i.eq(j).trigger("focus")
				}
			}
		}
	};
	var h = a.fn.dropdown;
	a.fn.dropdown = d, a.fn.dropdown.Constructor = g, a.fn.dropdown.noConflict = function() {
		return a.fn.dropdown = h, this
	}, a(document).on("click.bs.dropdown.data-api", b).on("click.bs.dropdown.data-api", ".dropdown form", function(a) {
		a.stopPropagation()
	}).on("click.bs.dropdown.data-api", f, g.prototype.toggle).on("keydown.bs.dropdown.data-api", f, g.prototype.keydown).on("keydown.bs.dropdown.data-api", '[role="menu"]', g.prototype.keydown).on("keydown.bs.dropdown.data-api", '[role="listbox"]', g.prototype.keydown)
}(jQuery), + function(a) {
	"use strict";

	function b(b, d) {
		return this.each(function() {
			var e = a(this),
				f = e.data("bs.modal"),
				g = a.extend({}, c.DEFAULTS, e.data(), "object" == typeof b && b);
			f || e.data("bs.modal", f = new c(this, g)), "string" == typeof b ? f[b](d) : g.show && f.show(d)
		})
	}
	var c = function(b, c) {
		this.options = c, this.$body = a(document.body), this.$element = a(b), this.$backdrop = this.isShown = null, this.scrollbarWidth = 0, this.options.remote && this.$element.find(".modal-content").load(this.options.remote, a.proxy(function() {
			this.$element.trigger("loaded.bs.modal")
		}, this))
	};
	c.VERSION = "3.3.2", c.TRANSITION_DURATION = 300, c.BACKDROP_TRANSITION_DURATION = 150, c.DEFAULTS = {
		backdrop: !0,
		keyboard: !0,
		show: !0
	}, c.prototype.toggle = function(a) {
		return this.isShown ? this.hide() : this.show(a)
	}, c.prototype.show = function(b) {
		var d = this,
			e = a.Event("show.bs.modal", {
				relatedTarget: b
			});
		this.$element.trigger(e), this.isShown || e.isDefaultPrevented() || (this.isShown = !0, this.checkScrollbar(), this.setScrollbar(), this.$body.addClass("modal-open"), this.escape(), this.resize(), this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', a.proxy(this.hide, this)), this.backdrop(function() {
			var e = a.support.transition && d.$element.hasClass("fade");
			d.$element.parent().length || d.$element.appendTo(d.$body), d.$element.show().scrollTop(0), d.options.backdrop && d.adjustBackdrop(), d.adjustDialog(), e && d.$element[0].offsetWidth, d.$element.addClass("in").attr("aria-hidden", !1), d.enforceFocus();
			var f = a.Event("shown.bs.modal", {
				relatedTarget: b
			});
			e ? d.$element.find(".modal-dialog").one("bsTransitionEnd", function() {
				d.$element.trigger("focus").trigger(f)
			}).emulateTransitionEnd(c.TRANSITION_DURATION) : d.$element.trigger("focus").trigger(f)
		}))
	}, c.prototype.hide = function(b) {
		b && b.preventDefault(), b = a.Event("hide.bs.modal"), this.$element.trigger(b), this.isShown && !b.isDefaultPrevented() && (this.isShown = !1, this.escape(), this.resize(), a(document).off("focusin.bs.modal"), this.$element.removeClass("in").attr("aria-hidden", !0).off("click.dismiss.bs.modal"), a.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", a.proxy(this.hideModal, this)).emulateTransitionEnd(c.TRANSITION_DURATION) : this.hideModal())
	}, c.prototype.enforceFocus = function() {
		a(document).off("focusin.bs.modal").on("focusin.bs.modal", a.proxy(function(a) {
			this.$element[0] === a.target || this.$element.has(a.target).length || this.$element.trigger("focus")
		}, this))
	}, c.prototype.escape = function() {
		this.isShown && this.options.keyboard ? this.$element.on("keydown.dismiss.bs.modal", a.proxy(function(a) {
			27 == a.which && this.hide()
		}, this)) : this.isShown || this.$element.off("keydown.dismiss.bs.modal")
	}, c.prototype.resize = function() {
		this.isShown ? a(window).on("resize.bs.modal", a.proxy(this.handleUpdate, this)) : a(window).off("resize.bs.modal")
	}, c.prototype.hideModal = function() {
		var a = this;
		this.$element.hide(), this.backdrop(function() {
			a.$body.removeClass("modal-open"), a.resetAdjustments(), a.resetScrollbar(), a.$element.trigger("hidden.bs.modal")
		})
	}, c.prototype.removeBackdrop = function() {
		this.$backdrop && this.$backdrop.remove(), this.$backdrop = null
	}, c.prototype.backdrop = function(b) {
		var d = this,
			e = this.$element.hasClass("fade") ? "fade" : "";
		if (this.isShown && this.options.backdrop) {
			var f = a.support.transition && e;
			if (this.$backdrop = a('<div class="modal-backdrop ' + e + '" />').prependTo(this.$element).on("click.dismiss.bs.modal", a.proxy(function(a) {
					a.target === a.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus.call(this.$element[0]) : this.hide.call(this))
				}, this)), f && this.$backdrop[0].offsetWidth, this.$backdrop.addClass("in"), !b) return;
			f ? this.$backdrop.one("bsTransitionEnd", b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : b()
		} else if (!this.isShown && this.$backdrop) {
			this.$backdrop.removeClass("in");
			var g = function() {
				d.removeBackdrop(), b && b()
			};
			a.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : g()
		} else b && b()
	}, c.prototype.handleUpdate = function() {
		this.options.backdrop && this.adjustBackdrop(), this.adjustDialog()
	}, c.prototype.adjustBackdrop = function() {
		this.$backdrop.css("height", 0).css("height", this.$element[0].scrollHeight)
	}, c.prototype.adjustDialog = function() {
		var a = this.$element[0].scrollHeight > document.documentElement.clientHeight;
		this.$element.css({
			paddingLeft: !this.bodyIsOverflowing && a ? this.scrollbarWidth : "",
			paddingRight: this.bodyIsOverflowing && !a ? this.scrollbarWidth : ""
		})
	}, c.prototype.resetAdjustments = function() {
		this.$element.css({
			paddingLeft: "",
			paddingRight: ""
		})
	}, c.prototype.checkScrollbar = function() {
		this.bodyIsOverflowing = document.body.scrollHeight > document.documentElement.clientHeight, this.scrollbarWidth = this.measureScrollbar()
	}, c.prototype.setScrollbar = function() {
		var a = parseInt(this.$body.css("padding-right") || 0, 10);
		this.bodyIsOverflowing && this.$body.css("padding-right", a + this.scrollbarWidth)
	}, c.prototype.resetScrollbar = function() {
		this.$body.css("padding-right", "")
	}, c.prototype.measureScrollbar = function() {
		var a = document.createElement("div");
		a.className = "modal-scrollbar-measure", this.$body.append(a);
		var b = a.offsetWidth - a.clientWidth;
		return this.$body[0].removeChild(a), b
	};
	var d = a.fn.modal;
	a.fn.modal = b, a.fn.modal.Constructor = c, a.fn.modal.noConflict = function() {
		return a.fn.modal = d, this
	}, a(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function(c) {
		var d = a(this),
			e = d.attr("href"),
			f = a(d.attr("data-target") || e && e.replace(/.*(?=#[^\s]+$)/, "")),
			g = f.data("bs.modal") ? "toggle" : a.extend({
				remote: !/#/.test(e) && e
			}, f.data(), d.data());
		d.is("a") && c.preventDefault(), f.one("show.bs.modal", function(a) {
			a.isDefaultPrevented() || f.one("hidden.bs.modal", function() {
				d.is(":visible") && d.trigger("focus")
			})
		}), b.call(f, g, this)
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.tooltip"),
				f = "object" == typeof b && b;
			(e || "destroy" != b) && (e || d.data("bs.tooltip", e = new c(this, f)), "string" == typeof b && e[b]())
		})
	}
	var c = function(a, b) {
		this.type = this.options = this.enabled = this.timeout = this.hoverState = this.$element = null, this.init("tooltip", a, b)
	};
	c.VERSION = "3.3.2", c.TRANSITION_DURATION = 150, c.DEFAULTS = {
		animation: !0,
		placement: "top",
		selector: !1,
		template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
		trigger: "hover focus",
		title: "",
		delay: 0,
		html: !1,
		container: !1,
		viewport: {
			selector: "body",
			padding: 0
		}
	}, c.prototype.init = function(b, c, d) {
		this.enabled = !0, this.type = b, this.$element = a(c), this.options = this.getOptions(d), this.$viewport = this.options.viewport && a(this.options.viewport.selector || this.options.viewport);
		for (var e = this.options.trigger.split(" "), f = e.length; f--;) {
			var g = e[f];
			if ("click" == g) this.$element.on("click." + this.type, this.options.selector, a.proxy(this.toggle, this));
			else if ("manual" != g) {
				var h = "hover" == g ? "mouseenter" : "focusin",
					i = "hover" == g ? "mouseleave" : "focusout";
				this.$element.on(h + "." + this.type, this.options.selector, a.proxy(this.enter, this)), this.$element.on(i + "." + this.type, this.options.selector, a.proxy(this.leave, this))
			}
		}
		this.options.selector ? this._options = a.extend({}, this.options, {
			trigger: "manual",
			selector: ""
		}) : this.fixTitle()
	}, c.prototype.getDefaults = function() {
		return c.DEFAULTS
	}, c.prototype.getOptions = function(b) {
		return b = a.extend({}, this.getDefaults(), this.$element.data(), b), b.delay && "number" == typeof b.delay && (b.delay = {
			show: b.delay,
			hide: b.delay
		}), b
	}, c.prototype.getDelegateOptions = function() {
		var b = {},
			c = this.getDefaults();
		return this._options && a.each(this._options, function(a, d) {
			c[a] != d && (b[a] = d)
		}), b
	}, c.prototype.enter = function(b) {
		var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);
		return c && c.$tip && c.$tip.is(":visible") ? void(c.hoverState = "in") : (c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c)), clearTimeout(c.timeout), c.hoverState = "in", c.options.delay && c.options.delay.show ? void(c.timeout = setTimeout(function() {
			"in" == c.hoverState && c.show()
		}, c.options.delay.show)) : c.show())
	}, c.prototype.leave = function(b) {
		var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);
		return c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c)), clearTimeout(c.timeout), c.hoverState = "out", c.options.delay && c.options.delay.hide ? void(c.timeout = setTimeout(function() {
			"out" == c.hoverState && c.hide()
		}, c.options.delay.hide)) : c.hide()
	}, c.prototype.show = function() {
		var b = a.Event("show.bs." + this.type);
		if (this.hasContent() && this.enabled) {
			this.$element.trigger(b);
			var d = a.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
			if (b.isDefaultPrevented() || !d) return;
			var e = this,
				f = this.tip(),
				g = this.getUID(this.type);
			this.setContent(), f.attr("id", g), this.$element.attr("aria-describedby", g), this.options.animation && f.addClass("fade");
			var h = "function" == typeof this.options.placement ? this.options.placement.call(this, f[0], this.$element[0]) : this.options.placement,
				i = /\s?auto?\s?/i,
				j = i.test(h);
			j && (h = h.replace(i, "") || "top"), f.detach().css({
				top: 0,
				left: 0,
				display: "block"
			}).addClass(h).data("bs." + this.type, this), this.options.container ? f.appendTo(this.options.container) : f.insertAfter(this.$element);
			var k = this.getPosition(),
				l = f[0].offsetWidth,
				m = f[0].offsetHeight;
			if (j) {
				var n = h,
					o = this.options.container ? a(this.options.container) : this.$element.parent(),
					p = this.getPosition(o);
				h = "bottom" == h && k.bottom + m > p.bottom ? "top" : "top" == h && k.top - m < p.top ? "bottom" : "right" == h && k.right + l > p.width ? "left" : "left" == h && k.left - l < p.left ? "right" : h, f.removeClass(n).addClass(h)
			}
			var q = this.getCalculatedOffset(h, k, l, m);
			this.applyPlacement(q, h);
			var r = function() {
				var a = e.hoverState;
				e.$element.trigger("shown.bs." + e.type), e.hoverState = null, "out" == a && e.leave(e)
			};
			a.support.transition && this.$tip.hasClass("fade") ? f.one("bsTransitionEnd", r).emulateTransitionEnd(c.TRANSITION_DURATION) : r()
		}
	}, c.prototype.applyPlacement = function(b, c) {
		var d = this.tip(),
			e = d[0].offsetWidth,
			f = d[0].offsetHeight,
			g = parseInt(d.css("margin-top"), 10),
			h = parseInt(d.css("margin-left"), 10);
		isNaN(g) && (g = 0), isNaN(h) && (h = 0), b.top = b.top + g, b.left = b.left + h, a.offset.setOffset(d[0], a.extend({
			using: function(a) {
				d.css({
					top: Math.round(a.top),
					left: Math.round(a.left)
				})
			}
		}, b), 0), d.addClass("in");
		var i = d[0].offsetWidth,
			j = d[0].offsetHeight;
		"top" == c && j != f && (b.top = b.top + f - j);
		var k = this.getViewportAdjustedDelta(c, b, i, j);
		k.left ? b.left += k.left : b.top += k.top;
		var l = /top|bottom/.test(c),
			m = l ? 2 * k.left - e + i : 2 * k.top - f + j,
			n = l ? "offsetWidth" : "offsetHeight";
		d.offset(b), this.replaceArrow(m, d[0][n], l)
	}, c.prototype.replaceArrow = function(a, b, c) {
		this.arrow().css(c ? "left" : "top", 50 * (1 - a / b) + "%").css(c ? "top" : "left", "")
	}, c.prototype.setContent = function() {
		var a = this.tip(),
			b = this.getTitle();
		a.find(".tooltip-inner")[this.options.html ? "html" : "text"](b), a.removeClass("fade in top bottom left right")
	}, c.prototype.hide = function(b) {
		function d() {
			"in" != e.hoverState && f.detach(), e.$element.removeAttr("aria-describedby").trigger("hidden.bs." + e.type), b && b()
		}
		var e = this,
			f = this.tip(),
			g = a.Event("hide.bs." + this.type);
		return this.$element.trigger(g), g.isDefaultPrevented() ? void 0 : (f.removeClass("in"), a.support.transition && this.$tip.hasClass("fade") ? f.one("bsTransitionEnd", d).emulateTransitionEnd(c.TRANSITION_DURATION) : d(), this.hoverState = null, this)
	}, c.prototype.fixTitle = function() {
		var a = this.$element;
		(a.attr("title") || "string" != typeof a.attr("data-original-title")) && a.attr("data-original-title", a.attr("title") || "").attr("title", "")
	}, c.prototype.hasContent = function() {
		return this.getTitle()
	}, c.prototype.getPosition = function(b) {
		b = b || this.$element;
		var c = b[0],
			d = "BODY" == c.tagName,
			e = c.getBoundingClientRect();
		null == e.width && (e = a.extend({}, e, {
			width: e.right - e.left,
			height: e.bottom - e.top
		}));
		var f = d ? {
				top: 0,
				left: 0
			} : b.offset(),
			g = {
				scroll: d ? document.documentElement.scrollTop || document.body.scrollTop : b.scrollTop()
			},
			h = d ? {
				width: a(window).width(),
				height: a(window).height()
			} : null;
		return a.extend({}, e, g, h, f)
	}, c.prototype.getCalculatedOffset = function(a, b, c, d) {
		return "bottom" == a ? {
			top: b.top + b.height,
			left: b.left + b.width / 2 - c / 2
		} : "top" == a ? {
			top: b.top - d,
			left: b.left + b.width / 2 - c / 2
		} : "left" == a ? {
			top: b.top + b.height / 2 - d / 2,
			left: b.left - c
		} : {
			top: b.top + b.height / 2 - d / 2,
			left: b.left + b.width
		}
	}, c.prototype.getViewportAdjustedDelta = function(a, b, c, d) {
		var e = {
			top: 0,
			left: 0
		};
		if (!this.$viewport) return e;
		var f = this.options.viewport && this.options.viewport.padding || 0,
			g = this.getPosition(this.$viewport);
		if (/right|left/.test(a)) {
			var h = b.top - f - g.scroll,
				i = b.top + f - g.scroll + d;
			h < g.top ? e.top = g.top - h : i > g.top + g.height && (e.top = g.top + g.height - i)
		} else {
			var j = b.left - f,
				k = b.left + f + c;
			j < g.left ? e.left = g.left - j : k > g.width && (e.left = g.left + g.width - k)
		}
		return e
	}, c.prototype.getTitle = function() {
		var a, b = this.$element,
			c = this.options;
		return a = b.attr("data-original-title") || ("function" == typeof c.title ? c.title.call(b[0]) : c.title)
	}, c.prototype.getUID = function(a) {
		do a += ~~(1e6 * Math.random()); while (document.getElementById(a));
		return a
	}, c.prototype.tip = function() {
		return this.$tip = this.$tip || a(this.options.template)
	}, c.prototype.arrow = function() {
		return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow")
	}, c.prototype.enable = function() {
		this.enabled = !0
	}, c.prototype.disable = function() {
		this.enabled = !1
	}, c.prototype.toggleEnabled = function() {
		this.enabled = !this.enabled
	}, c.prototype.toggle = function(b) {
		var c = this;
		b && (c = a(b.currentTarget).data("bs." + this.type), c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c))), c.tip().hasClass("in") ? c.leave(c) : c.enter(c)
	}, c.prototype.destroy = function() {
		var a = this;
		clearTimeout(this.timeout), this.hide(function() {
			a.$element.off("." + a.type).removeData("bs." + a.type)
		})
	};
	var d = a.fn.tooltip;
	a.fn.tooltip = b, a.fn.tooltip.Constructor = c, a.fn.tooltip.noConflict = function() {
		return a.fn.tooltip = d, this
	}
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.popover"),
				f = "object" == typeof b && b;
			(e || "destroy" != b) && (e || d.data("bs.popover", e = new c(this, f)), "string" == typeof b && e[b]())
		})
	}
	var c = function(a, b) {
		this.init("popover", a, b)
	};
	if (!a.fn.tooltip) throw new Error("Popover requires tooltip.js");
	c.VERSION = "3.3.2", c.DEFAULTS = a.extend({}, a.fn.tooltip.Constructor.DEFAULTS, {
		placement: "right",
		trigger: "click",
		content: "",
		template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	}), c.prototype = a.extend({}, a.fn.tooltip.Constructor.prototype), c.prototype.constructor = c, c.prototype.getDefaults = function() {
		return c.DEFAULTS
	}, c.prototype.setContent = function() {
		var a = this.tip(),
			b = this.getTitle(),
			c = this.getContent();
		a.find(".popover-title")[this.options.html ? "html" : "text"](b), a.find(".popover-content").children().detach().end()[this.options.html ? "string" == typeof c ? "html" : "append" : "text"](c), a.removeClass("fade top bottom left right in"), a.find(".popover-title").html() || a.find(".popover-title").hide()
	}, c.prototype.hasContent = function() {
		return this.getTitle() || this.getContent()
	}, c.prototype.getContent = function() {
		var a = this.$element,
			b = this.options;
		return a.attr("data-content") || ("function" == typeof b.content ? b.content.call(a[0]) : b.content)
	}, c.prototype.arrow = function() {
		return this.$arrow = this.$arrow || this.tip().find(".arrow")
	}, c.prototype.tip = function() {
		return this.$tip || (this.$tip = a(this.options.template)), this.$tip
	};
	var d = a.fn.popover;
	a.fn.popover = b, a.fn.popover.Constructor = c, a.fn.popover.noConflict = function() {
		return a.fn.popover = d, this
	}
}(jQuery), + function(a) {
	"use strict";

	function b(c, d) {
		var e = a.proxy(this.process, this);
		this.$body = a("body"), this.$scrollElement = a(a(c).is("body") ? window : c), this.options = a.extend({}, b.DEFAULTS, d), this.selector = (this.options.target || "") + " .nav li > a", this.offsets = [], this.targets = [], this.activeTarget = null, this.scrollHeight = 0, this.$scrollElement.on("scroll.bs.scrollspy", e), this.refresh(), this.process()
	}

	function c(c) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.scrollspy"),
				f = "object" == typeof c && c;
			e || d.data("bs.scrollspy", e = new b(this, f)), "string" == typeof c && e[c]()
		})
	}
	b.VERSION = "3.3.2", b.DEFAULTS = {
		offset: 10
	}, b.prototype.getScrollHeight = function() {
		return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	}, b.prototype.refresh = function() {
		var b = "offset",
			c = 0;
		a.isWindow(this.$scrollElement[0]) || (b = "position", c = this.$scrollElement.scrollTop()), this.offsets = [], this.targets = [], this.scrollHeight = this.getScrollHeight();
		var d = this;
		this.$body.find(this.selector).map(function() {
			var d = a(this),
				e = d.data("target") || d.attr("href"),
				f = /^#./.test(e) && a(e);
			return f && f.length && f.is(":visible") && [
				[f[b]().top + c, e]
			] || null
		}).sort(function(a, b) {
			return a[0] - b[0]
		}).each(function() {
			d.offsets.push(this[0]), d.targets.push(this[1])
		})
	}, b.prototype.process = function() {
		var a, b = this.$scrollElement.scrollTop() + this.options.offset,
			c = this.getScrollHeight(),
			d = this.options.offset + c - this.$scrollElement.height(),
			e = this.offsets,
			f = this.targets,
			g = this.activeTarget;
		if (this.scrollHeight != c && this.refresh(), b >= d) return g != (a = f[f.length - 1]) && this.activate(a);
		if (g && b < e[0]) return this.activeTarget = null, this.clear();
		for (a = e.length; a--;) g != f[a] && b >= e[a] && (!e[a + 1] || b <= e[a + 1]) && this.activate(f[a])
	}, b.prototype.activate = function(b) {
		this.activeTarget = b, this.clear();
		var c = this.selector + '[data-target="' + b + '"],' + this.selector + '[href="' + b + '"]',
			d = a(c).parents("li").addClass("active");
		d.parent(".dropdown-menu").length && (d = d.closest("li.dropdown").addClass("active")), d.trigger("activate.bs.scrollspy")
	}, b.prototype.clear = function() {
		a(this.selector).parentsUntil(this.options.target, ".active").removeClass("active")
	};
	var d = a.fn.scrollspy;
	a.fn.scrollspy = c, a.fn.scrollspy.Constructor = b, a.fn.scrollspy.noConflict = function() {
		return a.fn.scrollspy = d, this
	}, a(window).on("load.bs.scrollspy.data-api", function() {
		a('[data-spy="scroll"]').each(function() {
			var b = a(this);
			c.call(b, b.data())
		})
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.tab");
			e || d.data("bs.tab", e = new c(this)), "string" == typeof b && e[b]()
		})
	}
	var c = function(b) {
		this.element = a(b)
	};
	c.VERSION = "3.3.2", c.TRANSITION_DURATION = 150, c.prototype.show = function() {
		var b = this.element,
			c = b.closest("ul:not(.dropdown-menu)"),
			d = b.data("target");
		if (d || (d = b.attr("href"), d = d && d.replace(/.*(?=#[^\s]*$)/, "")), !b.parent("li").hasClass("active")) {
			var e = c.find(".active:last a"),
				f = a.Event("hide.bs.tab", {
					relatedTarget: b[0]
				}),
				g = a.Event("show.bs.tab", {
					relatedTarget: e[0]
				});
			if (e.trigger(f), b.trigger(g), !g.isDefaultPrevented() && !f.isDefaultPrevented()) {
				var h = a(d);
				this.activate(b.closest("li"), c), this.activate(h, h.parent(), function() {
					e.trigger({
						type: "hidden.bs.tab",
						relatedTarget: b[0]
					}), b.trigger({
						type: "shown.bs.tab",
						relatedTarget: e[0]
					})
				})
			}
		}
	}, c.prototype.activate = function(b, d, e) {
		function f() {
			g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !1), b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", !0), h ? (b[0].offsetWidth, b.addClass("in")) : b.removeClass("fade"), b.parent(".dropdown-menu") && b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !0), e && e()
		}
		var g = d.find("> .active"),
			h = e && a.support.transition && (g.length && g.hasClass("fade") || !!d.find("> .fade").length);
		g.length && h ? g.one("bsTransitionEnd", f).emulateTransitionEnd(c.TRANSITION_DURATION) : f(), g.removeClass("in")
	};
	var d = a.fn.tab;
	a.fn.tab = b, a.fn.tab.Constructor = c, a.fn.tab.noConflict = function() {
		return a.fn.tab = d, this
	};
	var e = function(c) {
		c.preventDefault(), b.call(a(this), "show")
	};
	a(document).on("click.bs.tab.data-api", '[data-toggle="tab"]', e).on("click.bs.tab.data-api", '[data-toggle="pill"]', e)
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.affix"),
				f = "object" == typeof b && b;
			e || d.data("bs.affix", e = new c(this, f)), "string" == typeof b && e[b]()
		})
	}
	var c = function(b, d) {
		this.options = a.extend({}, c.DEFAULTS, d), this.$target = a(this.options.target).on("scroll.bs.affix.data-api", a.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", a.proxy(this.checkPositionWithEventLoop, this)), this.$element = a(b), this.affixed = this.unpin = this.pinnedOffset = null, this.checkPosition()
	};
	c.VERSION = "3.3.2", c.RESET = "affix affix-top affix-bottom", c.DEFAULTS = {
		offset: 0,
		target: window
	}, c.prototype.getState = function(a, b, c, d) {
		var e = this.$target.scrollTop(),
			f = this.$element.offset(),
			g = this.$target.height();
		if (null != c && "top" == this.affixed) return c > e ? "top" : !1;
		if ("bottom" == this.affixed) return null != c ? e + this.unpin <= f.top ? !1 : "bottom" : a - d >= e + g ? !1 : "bottom";
		var h = null == this.affixed,
			i = h ? e : f.top,
			j = h ? g : b;
		return null != c && c >= e ? "top" : null != d && i + j >= a - d ? "bottom" : !1
	}, c.prototype.getPinnedOffset = function() {
		if (this.pinnedOffset) return this.pinnedOffset;
		this.$element.removeClass(c.RESET).addClass("affix");
		var a = this.$target.scrollTop(),
			b = this.$element.offset();
		return this.pinnedOffset = b.top - a
	}, c.prototype.checkPositionWithEventLoop = function() {
		setTimeout(a.proxy(this.checkPosition, this), 1)
	}, c.prototype.checkPosition = function() {
		if (this.$element.is(":visible")) {
			var b = this.$element.height(),
				d = this.options.offset,
				e = d.top,
				f = d.bottom,
				g = a("body").height();
			"object" != typeof d && (f = e = d), "function" == typeof e && (e = d.top(this.$element)), "function" == typeof f && (f = d.bottom(this.$element));
			var h = this.getState(g, b, e, f);
			if (this.affixed != h) {
				null != this.unpin && this.$element.css("top", "");
				var i = "affix" + (h ? "-" + h : ""),
					j = a.Event(i + ".bs.affix");
				if (this.$element.trigger(j), j.isDefaultPrevented()) return;
				this.affixed = h, this.unpin = "bottom" == h ? this.getPinnedOffset() : null, this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix", "affixed") + ".bs.affix")
			}
			"bottom" == h && this.$element.offset({
				top: g - b - f
			})
		}
	};
	var d = a.fn.affix;
	a.fn.affix = b, a.fn.affix.Constructor = c, a.fn.affix.noConflict = function() {
		return a.fn.affix = d, this
	}, a(window).on("load", function() {
		a('[data-spy="affix"]').each(function() {
			var c = a(this),
				d = c.data();
			d.offset = d.offset || {}, null != d.offsetBottom && (d.offset.bottom = d.offsetBottom), null != d.offsetTop && (d.offset.top = d.offsetTop), b.call(c, d)
		})
	})
}(jQuery);


/* Lazy Load Images */

// $(document).ready(function(){

//    $("img.lazyload").lazyload();

// });

/* Lazy Load Background Images */



/*
 *  Custom Theme Javascript Code.
 *
 */
jQuery(document).ready(function($) {


	"use strict";

	submenuToggle();
	offCanvasToggle();
	product();


	$('[data-toggle="tooltip"]').tooltip();

	/*
	 * Submit currency select on select change.
	 *
	 */
	$('.shopify-currency-form select').on('change', function() {

		$(this).parents('form').submit();

	});

	/*
	 *  Add/Remove the "stuck" class to the site header
	 *  based on current position.
	 *
	 */
	var currentPosition = $(window).scrollTop();
	if (currentPosition > 80) {
		$('.site-header').addClass('stuck');
	}
	$(window).on('scroll', function(e) {

		currentPosition = $(window).scrollTop();
		if (currentPosition > 80) {
			$('.site-header').addClass('stuck');
		} else {
			$('.site-header').removeClass('stuck');
		}

	});

	/*
	 *  Initiate Cycle2 Slider.
	 *  This is used for when a banner section is set to "Slide" mode.
	 *  Also used when a product grid is set to "Carousel" mode and if a service has "Mobile Carousel" enabled.
	 *
	 *  @link  http://jquery.malsup.com/cycle2/
	 *
	 */
	$('.slides').cycle({
		swipe: true
	});

	var viewport = $(window).width();
	var visibleItems = 5;
	var isMobileCarouselActive = false;
	var isProductCarouselActive = false;

	if (viewport < 1200) {
		visibleItems = 3;
		$('.services-mobile-carousel').cycle({
			fx: 'scrollHorz',
			slides: '> .service-wrapper',
			swipe: true
		});
		isMobileCarouselActive = true;
	}
    if (viewport < 767) {
		$('.enabled-mobile').cycle({
			fx: 'scrollHorz',
			slides: '> div[class*=col]',
			swipe: true
		});
		isMobileCarouselActive = true;
	}
    if (viewport < 768) {
		visibleItems = 2;
	}
	if (viewport < 480) {
		visibleItems = 1;
	}

	if (viewport < 1200) {
		visibleItems = 3;
		$('.brands-mobile-carousel').cycle({
			fx: 'scrollHorz',
			slides: '> .service-wrapper',
			swipe: true
		});
		isMobileCarouselActive = true;
	}
	if (viewport < 768) {
		visibleItems = 2;
	}
	if (viewport < 480) {
		visibleItems = 1;
	}

	$('.carousel').cycle({
		fx: 'carousel',
		slides: '> .product-column',
		timeout: 0,
		speed: 200,
		carouselVisible: visibleItems,
		carouselFluid: true,
		allowWrap: false,
		autoHeight: 'calc',
		swipe: true
	});
	isProductCarouselActive = true;

	$(window).on('resize', function() {

		viewport = $(window).width();

		if (isProductCarouselActive) {
			$('.carousel').cycle('destroy');
		}
		if (isMobileCarouselActive) {
			$('.services-mobile-carousel').cycle('destroy');
		}
        if (isMobileCarouselActive) {
			$('.enabled-mobile').cycle('destroy');
		}
		if (isMobileCarouselActive) {
			$('.brands-mobile-carousel').cycle('destroy');
		}

		if (viewport < 1200) {
			visibleItems = 3;
			$('.services-mobile-carousel').cycle({
				fx: 'scrollHorz',
				slides: '> .service-wrapper',
				swipe: true
			});
			isMobileCarouselActive = true;
		}
          if (viewport < 767) {
    		$('.enabled-mobile').cycle({
    			fx: 'scrollHorz',
    			slides: '> div[class*=col]',
    			swipe: true
    		});
    		isMobileCarouselActive = true;
    	  }
		if (viewport < 1200) {
			visibleItems = 3;
			$('.brands-mobile-carousel').cycle({
				fx: 'scrollHorz',
				slides: '> .service-wrapper',
				swipe: true
			});
			isMobileCarouselActive = true;
		}
		if (viewport < 768) {
			visibleItems = 2;
		}
		if (viewport < 480) {
			visibleItems = 1;
		}

		$('.carousel').cycle({
			fx: 'carousel',
			slides: '> .product-column',
			timeout: 0,
			speed: 200,
			carouselVisible: visibleItems,
			carouselFluid: true,
			allowWrap: false,
			autoHeight: 'calc',
			swipe: true
		});
		isProductCarouselActive = true;

	});

	/*
	 *  Expand/Collapse sidebar menus on mobile.
	 *
	 */
	$('.sidebar-expand').on('click', function(e) {

		e.preventDefault();

		var filter_menu = $(this).next().next();
		var icon = $(this).find('i');

		filter_menu.toggleClass('expanded').slideToggle(100);
		if (icon.hasClass('fa-plus')) {
			icon.addClass('fa-minus').removeClass('fa-plus');
		} else {
			icon.addClass('fa-plus').removeClass('fa-minus');
		}

	});

	/*
	 * Toggle the visibility of account forms.
	 *
	 */
	$('.address-edit-toggle').on('click', function(e) {

		e.preventDefault();
		$(this).parent().next().removeClass('hidden');

	});

	$('.address-edit-cancel').on('click', function(e) {

		e.preventDefault();
		$(this).parent().parent().addClass('hidden');

	});

	$('.recover-password-toggle').on('click', function(e) {

		e.preventDefault();
		$(this).parent().next().toggleClass('hidden');

	});

	/*
	 *  Expand/collapse rich text sections.
	 *
	 */
	$('.rich-accordion-header').on('click', function(e) {

		e.preventDefault();

		$(this).parent().parent().next().toggleClass('expanded');
		$(this).find('.fa').toggleClass('fa-minus').toggleClass('fa-plus');

	});



	/*
	 *  Update the main product featured image when thumbnails are clicked.
	 *  Also uses Zoom plugin for product zoom.
	 *
	 *  @link  http://www.jacklmoore.com/zoom
	 *
	 */
	$('.product-thumbnail').on('click', function() {

		var new_url = $(this).attr('data-featured');
		var master_url = $(this).attr('data-master');

		$('.product-featured-image').replaceWith('<img class="product-featured-image" src="' + new_url + '" alt="" data-zoom="' + master_url + '">');
		$('.product-zoom').trigger('zoom.destroy');


		if ($('.product-featured-image').length) {

			$('.product-featured-image')
				//.wrap('<span style="display:inline-block"></span>')
				//.css('display', 'block')
				.parent()
				.zoom({
					url: $(this).find('img').attr('data-zoom'),
					touch: false
				});
		}

		/*if(jQuery.zoom) {
			
			$('.product-zoom').zoom({
				
				url:   master_url,
				touch: false
				
			});
			
		}*/

	});


	/*
	if(jQuery.zoom) {
	
		$('.product-zoom').zoom({
		
			url:   $('.product-featured-image-wrapper').find('img').attr('data-zoom'),
			touch: false
	
		});
	
	}
    */

	/*
	 *  Add "Load More" functionality via ajax.
	 *
	 */
	var triggered = false;

	$('.load-more').off('click').on('click', function(e) {

		e.preventDefault();

		var target = $('.load-more').attr('href');
		if (triggered == false) {

			triggered = true;
			$.ajax({

				url: target,
				type: 'GET',
				success: function(data) {
					var newTarget = $(data).find('.load-more').attr('href');
					if (is_collection_page || is_search_page) {
						var filteredData = $(data).find('.product-column');
					} else {
						var filteredData = $(data).find('.blog-column');
					}

					if (is_collection_page || is_search_page) {
						$('.product-loop').append(filteredData);
					} else {
						$('.blog-loop').append(filteredData);
					}

					$('.load-more').attr('href', newTarget);
					if (!newTarget) {
						$('.load-more').remove();
					}

					triggered = false;
					addToCart();

					if (is_collection_page) {

						$('[data-toggle="tooltip"]').tooltip();
						Array.from($(".collection-page-options")).forEach(item => {

							if (!$(item).find(".collection-page-option").length) {
								$(item).hide();
							}

						});
					}

				}

			});

		}

	});

	/*
	 * Toggle the cart sidebar on/off.
	 *
	 */
	$('.cart-toggle').on('click', function(e) {
		e.preventDefault();
		$('.off-canvas-cart').addClass('in');
	});

	$('.header-cart-contents-close, .btn-continue-shopping, .off-canvas-cart-background').on('click', function(e) {
		e.preventDefault();
		$('.off-canvas-cart').removeClass('in');
	});

	/*
	 *  Add sorting functionality to collection pages.
	 *
	 */
	if (is_collection_page) {

		/*
		 *  Sort products by default Shopify sort order
		 *
		 */
		Shopify.queryParams = {};
		if (location.search.length) {

			for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {

				aKeyValue = aCouples[i].split('=');

				if (aKeyValue.length > 1) {

					Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);

				}

			}

		}

		$('#sort-by')
			.val(current_sort_by)
			.bind('change', function() {

				Shopify.queryParams.sort_by = jQuery(this).val();
				location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');

			});

		/*
		 *  Change the number of products to view per page.
		 *
		 */
		$('#num-products').on('change', function(e) {

			var url = $(this).val();
			window.location.href = url;

		});

	}

	addToCart();

});

/*
 *  Add products to the cart object via ajax.
 *  Used on collection pages.
 *
 *  @link  https://help.shopify.com/en/themes/development/getting-started/using-ajax-api
 *
 */
function addToCart() {

	$('.product-modals').off('click').on('click', '.modal-product-add-to-cart', function(e) {

		e.preventDefault();

		var form = $(this).parent();

		$.ajax({

			type: 'POST',
			url: '/cart/add.js',
			dataType: 'json',
			data: form.serialize(),
			success: function(product) {

				cartCount++;
				cartTotal += product.price;

				var cartHTML = '' +

					'<div class="shop-icon-basket-inner">' +
					'<i class="' + cartIcon + '"></i>' +
					'<span class="cart-item-count">' + cartCount + '</span>' +
					'</div>';

				$('.shop-icon-basket-inner').replaceWith(cartHTML);

				if (has_icon_text) {

					var icon_text = '<span class="icon-label icon-label-cart"><span class="money">' + Shopify.formatMoney(cartTotal) + '</span></span>';
					$('.icon-label-cart').replaceWith(icon_text);

				}

				var mobileCartHTML = '' +

					'<div class="mobile-cart-wrapper">' +
					'<a href="/cart" class="mobile-cart"><i class="' + cartIcon + '"></i></a>' +
					'<span class="cart-item-count">' + cartCount + '</span>' +
					'</div>';

				$('.mobile-cart-wrapper').replaceWith(mobileCartHTML);

				var pos = product.image.lastIndexOf('.');
				var product_image_small = product.image.substring(0, pos) + '_120x120_crop_center.' + product.image.substring(pos + 1);
				var trimmed_title = product.title.substring(0, 20);
				var priceHTML = '';
				var VATHTML = '';

				if (displayVAT) {

					var priceWithoutVAT = cartTotal;
					var priceWithVAT = cartTotal * VATValue;

					priceHTML += '<span class="without-vat">' + Shopify.formatMoney(priceWithoutVAT) + '<span class="vat-text"> ' + VATTextWithout + '</span></span>';
					priceHTML += '<span class="with-vat">' + Shopify.formatMoney(priceWithVAT) + '<span class="vat-text"> ' + VATTextWith + '</span></span>';

					VATHTML = '<span class="vat-text">' + VATTextWithout + '</span>';

				} else {

					priceHTML += Shopify.formatMoney(cartTotal);

				}

				var itemHTML = '' +

					'<div class="header-cart-contents-item d-flex">' +
					'<div class="header-cart-contents-product-image">' +
					'<a href="' + product.url + '">' +
					'<img src="' + product_image_small + '" alt="' + product.title + '">' +
					'</a>' +
					'</div>' +
					'<div class="header-cart-contents-product-details d-flex flex-column justify-content-center text-left">' +
					'<span class="header-cart-contents-product-quantity">' + theme.strings.qty + ' 1</span>' +
					'<h6 class="header-cart-contents-product-title">' +
					'<strong><a href="' + product.url + '">' + trimmed_title + '&hellip;</a></strong>' +
					'</h6>' +
					'<span class="header-cart-contents-product-price">' + Shopify.formatMoney(product.price) + VATHTML + '</span>' +
					'</div>' +
					'</div>';

				$(itemHTML).prependTo('.header-cart-loop');

				if (cartCount == 1) {
					$('.no-items').remove();
				}

				$('.header-cart-contents-total-value').html(priceHTML);
				$('.modal-product').modal('hide');
				$('.modal-product').on('hidden.bs.modal', function(e) {
					$('.off-canvas-cart').addClass('in');
				});

			},
			error: function(error) {
				console.log(error.responseText);
			}

		});

	});

}


function product() {

	let $productContainer = $(".product-page");
	let sectionId = $($productContainer).data("section-id");

	if (!$('#ProductJson-' + sectionId).html()) {
		return;
	}

	let productJson = JSON.parse(
		document.getElementById('ProductJson-' + sectionId).innerHTML
	);

	var selectCallback = function(variant, selector) {


		// BEGIN SWATCHES
		if (variant) {
			var form = $("#AddToCartForm");
			$(".variant-link").removeClass("selected");
			for (var i = 0, length = variant.options.length; i < length; i++) {
				var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] + '"]');
				if (radioButton.length) {
					radioButton.get(0).checked = true;

					radioButton.closest(".variant-link").addClass("selected")


				}
			}

		}
		// END SWATCHES

	};

	function _updateInStock(variant) {

		let variant_quantity = productVariantQuantites[variant.id] || 0;

		let productSettings = window.productSettingsJson;

		let inStockHtml = "";
		if (variant_quantity > 0) {
			if (productSettings.product_in_stock) {
				inStockHtml += `<span class="product-in-stock">`;
				if (productSettings.show_quantity) {
					inStockHtml += `<span class="quantity">${variant_quantity}</span>`;
				}
				inStockHtml += `${productSettings.product_in_stock}</span>`;
			}
			if (productSettings.product_extra_info) {
				inStockHtml += `<span class="product-extra-info">${productSettings.product_extra_info}</span>`;
			}
		} else {
			if (productSettings.product_out_of_stock) {
				inStockHtml += `<span class="product-out-of-stock">${productSettings.product_out_of_stock}</span>`;
			}
			if (productSettings.product_out_of_stock_extra_info) {
				inStockHtml += `<span class="product-out-of-stock-extra-info">${productSettings.product_out_of_stock_extra_info}</span>`;
			}
		}

		$(".product-page").find(".in-stock-details").html(inStockHtml);

	}

	function _updateSKU(variant) {


		if (variant && variant.sku) {
			$(".product-page").find(".product-sku").html(`SKU: ${variant.sku}`);
		}

	}

	function _updatePrices(variant) {

		let productSettings = window.productSettingsJson;

		if (variant) {

			let vat = productSettings.vat;
			let money_without_currency_format = productSettings.money_without_currency_format;
			let vat_text_without = productSettings.vat_text_without;
			let vat_text_with = productSettings.vat_text_with;

			let priceFieldHtml = "";
			if (!variant.compare_at_price || variant.compare_at_price == 0 || variant.price == variant.compare_at_price) {

				if (productSettings.display_vat) {
					var priceWithoutVAT = variant.price;
					var priceWithVAT = variant.price * vat;
					var comparePrice = variant.compare_at_price;

					priceFieldHtml += `<span class="product-price original-price without-vat">${Shopify.formatMoney(variant.price, money_without_currency_format )}`;

					if (vat_text_without) {

						priceFieldHtml += `<span class="vat-text">${productSettings.vat_text_without}</span>`;
					}
					priceFieldHtml += `</span>`;

					let _price = variant.price * productSettings.vat;
					priceFieldHtml += `<span class="product-price original-price with-vat">${Shopify.formatMoney(_price, money_without_currency_format )}`;

					if (productSettings.vat_text_without) {

						priceFieldHtml += `<span class="vat-text">${productSettings.vat_text_with}</span>`;
					}
					priceFieldHtml += `</span>`;
				} else {

					priceFieldHtml += `<span class="product-price original-price">${Shopify.formatMoney(variant.price, money_without_currency_format )}</span>`;
				}
			} else {

				let saving = variant.compare_at_price - variant.price;
				let saving_percentage = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)

				if (productSettings.display_vat) {

					priceFieldHtml += `<span class="product-price sale-price"> ${Shopify.formatMoney(variant.price, money_without_currency_format )}`;

					if (productSettings.vat_text_without) {

						priceFieldHtml += `<span class="vat-text">${productSettings.vat_text_without}</span>`;
					}
					priceFieldHtml += `</span>`;
				} else {

					priceFieldHtml += `<span class="product-price sale-price"> ${Shopify.formatMoney(variant.price, money_without_currency_format )}</span>`;

				}
				priceFieldHtml += `<span class="product-price original-price original-price-text">Was ${Shopify.formatMoney(variant.compare_at_price, money_without_currency_format )}</span><span class="product-save saveText">Save ${Shopify.formatMoney(saving, money_without_currency_format )} (${saving_percentage}% OFF)</span>`;

			}
			$("#price-field").html(priceFieldHtml);
		}

	}

	function _updateMedia(variant) {
		console.log('Allright then: ', variant, variant.featured_media);
		if (variant && variant.featured_media) {

			var mediaId = variant.featured_media.id;
			var $newMedia = $(".product_media_element[data-media-id='" + mediaId + "']");
			var $otherMedia = $(".product_media_element:not([data-media-id='" + mediaId + "'])");


			$newMedia.show();
			$otherMedia.hide();
			$(".product-images .synergy_image_thumb").removeClass("active-thumb");
			$(".product-images .synergy_image_thumb[data-media-id='" + mediaId + "']").addClass("active-thumb");

		}

		if ($('.product-featured-image').length) {

			$('.product-featured-image')
				//.wrap('<span style="display:inline-block"></span>')
				//.css('display', 'block')
				.parent()
				.zoom({
					url: $(this).find('img').attr('data-zoom'),
					touch: false
				});
		}
	}

	function _updateMasterSelect(variant) {

		if (variant)
			$('#id').val(variant.id);
	}

	function _AddToCartButtons(variant) {

		if (variant && variant.available) {
			$('#AddToCart').removeClass('disabled').removeAttr('disabled').val('Add to Cart');
		} else {
			$('#AddToCart').val('Sold Out').addClass('disabled').attr('disabled', 'disabled');
		}
	}

	//   new Shopify.OptionSelectors("product-select", { product: productJson, onVariantSelected: selectCallback, enableHistoryState: true });
	//   new Shopify.OptionSelectors("product-select-"+productId, { product: productJson, onVariantSelected: selectCallback, enableHistoryState: enable_history });
	// Above causes Variants to repeat but needed to display stock in header under title

}
/*
 *  Dynamic search bar functionality.
 *
 *  Adds the ability for users to view porducts as they're typing search terms.
 *
 */
$(function() {

	var currentAjaxRequest = null;
	var searchForms = $('form[action="/search"]').each(function() {

		var input = $(this).find('input[name="q"]');
		input.attr('autocomplete', 'off').bind('keyup change', function() {

			var term = $(this).val();
			var form = $(this).closest('form');

			var searchURL = '/search?type=product&q=*' + term + '*';
			var resultsList = $('.ajax-search-results');

			if (term.length > 3 && term !== $(this).attr('data-old-term')) {

				$(this).attr('data-old-term', term);
				if (currentAjaxRequest !== null) currentAjaxRequest.abort();

				currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {

					resultsList.empty();

					if (data.results_count === 0) {

						resultsList.html('<p class="ajax-no-results">' + theme.strings.nothingFound + '</p>');
						resultsList.fadeIn(200);

					} else {

						$.each(data.results, function(index, item) {

							var ajax_search_html = '' +

								'<a href="' + item.url + '" class="ajax-search-item d-flex justify-content-start align-items-center">' +
								'<img class="ajax-search-item-thumbnail" src="' + item.thumbnail + '" src="' + item.title + '">' +
								'<div class="ajax-search-content">' +
								'<h6 class="ajax-search-item-title">' + item.title + '</h6>' +
								'<span class="ajax-search-item-price">' + item.price + '</span>' +
								'</div>' +
								'</a>';

							resultsList.append(ajax_search_html);

						});

						if (data.results_count > 5) {
							resultsList.append('<a class="ajax-search-more" href="' + searchURL + '">' + theme.strings.view + ' ' + data.results_count + ' ' + theme.strings.moreItems + '</a>');
						}
						resultsList.fadeIn(200);

					}

				});

			}

		});

	});

	$('body').bind('click', function() {

		$('.ajax-search-results').hide();

	});

});

/*
 *  Dynamic quick view functionality.
 *
 *  Adds the ability for users to view product information dynamically.
 *
 
$(function() {
	
	$('.quick-view-button').on('click', function(e){
		
		e.preventDefault();
		
		var currentButton  = $(this);
		var modalContainer = currentButton.parent().parent().next();
		var productHandle  = $(this).data('product-handle');
		
		$.getJSON('/products/' + productHandle + '.js', function(product) {
			
			var maxLength = 240;
			var excerpt   = product.description.substr(0, maxLength);
			var markup    = '';
			var variants  = product.variants;
			
			excerpt = excerpt.substr(0, Math.min(excerpt.length, excerpt.lastIndexOf(" "))) + '&hellip;'; // Trim the description without cutting off any words.
			
			markup += '<div class="modal-product modal fade" id="product-content-for-' + product.id + '" tabindex="-1" role="dialog" aria-labelledby="product-content-for-' + product.id + '" aria-hidden="true">';
			markup += '<div class="modal-dialog modal-dialog-centered modal-xl" role="document">';
			markup += '<div class="modal-content">';
			markup += '<div class="modal-body">';
			markup += '<div class="container-fluid">';
			markup += '<div class="row">';
			markup += '<div class="col-lg-6">';
			markup += '<div class="modal-product-featured-image mb-5 mb-lg-0">';
			markup += '<img src="' + product.featured_image + '" alt="' + product.title + '">';
			markup += '</div>';
			markup += '</div>';
			markup += '<div class="col-lg-6">';
			markup += '<header class="modal-product-header">';
			markup += '<h3 class="modal-product-title">' + product.title + '</h3>';
		
			markup += '<p class="modal-product-meta">';
			markup += '<span class="modal-product-vendor">' + product.vendor + '</span>';
			
			if( product.available ) {
				markup += '<span class="modal-product-in-stock">' + theme.strings.available + '</span>';
			} else {
				markup += '<span class="modal-product-out-of-stock">' + theme.strings.unavailable + '</span>';
			}
			
			markup += '<p class="modal-product-price">';
			if( product.price === product.compare_at_price || product.compare_at_price === null ) {
				if( displayVAT ) {
					markup += '<span class="modal-product-price-normal">';
					markup += '<span class="without-vat">' + Shopify.formatMoney(product.price) + '<span class="vat-text"> ' + VATTextWithout + '</span></span>';
					markup += '<span class="with-vat">' + Shopify.formatMoney(product.price * VATValue ) + '<span class="vat-text"> ' + VATTextWith + '</span></span>';
					markup += '</span>';
				} else {
					markup += '<span class="modal-product-price-normal">' + Shopify.formatMoney(product.price) + '</span>';
				}
			} else {
				if( displayVAT ) {
					markup += '<span class="modal-product-price-original">' + Shopify.formatMoney(product.compare_at_price) + '</span><span class="modal-product-price-saving">' + Shopify.formatMoney(product.price) + '<span class="vat-text"> ' + VATTextWithout + '</span></span>';
				} else {
					markup += '<span class="modal-product-price-original">' + Shopify.formatMoney(product.compare_at_price) + '</span><span class="modal-product-price-saving">' + Shopify.formatMoney(product.price) + '</span>';
				}
			}
			markup += '</p>';
			markup += '</header>';
			markup += '<div class="modal-product-content">';
			markup += '<p>' + excerpt + '</p>';
			markup += '</div>';
			markup += '<footer class="modal-product-footer">';
			markup += '<form class="modal-product-add-to-cart-form" method="post" action="/cart/add">';
			markup += '<input type="hidden" name="id" value="' + variants[0].id + '">';
			markup += '<input type="submit" value="Quick Add" class="modal-product-add-to-cart btn btn-secondary">';
			markup += '<a href="' + product.url + '" class="btn btn-secondary">' + theme.strings.viewProduct + '</a>'; 
			markup += '</form>';
			markup += '<div class="social-share d-flex justify-content-start">';
			markup += '<span class="share-icon share"><i class="fas fa-share-alt"></i></span>';
			markup += '<ul class="social-share-icons d-flex justify-content-start">';
			markup += '<li><a href="https://twitter.com/intent/tweet?url=' + shopURL + product.url + '&text=' + product.title + '" class="share-icon twitter" target="_blank"><i class="fab fa-twitter"></i></a></li>';
			markup += '<li><a href="https://www.facebook.com/sharer.php?u=' + shopURL + product.url + '" class="share-icon facebook" target="_blank"><i class="fab fa-facebook-f"></i></a></li>';
			markup += '<li><a href="https://www.linkedin.com/shareArticle?mini=true&url={{ shop.url }}{{ url }}" class="share-icon linkedin" target="_blank"><i class="fab fa-linkedin-in"></i></a></li>';
			markup += '<li><a href="http://pinterest.com/pin/create/link/?url=' + shopURL + product.url + '" class="share-icon pinterest" target="_blank"><i class="fab fa-pinterest-p"></i></a></li>';
			markup += '</ul>';
			markup += '</div>';
			markup += '</footer>';
			markup += '</div>';
			markup += '</div>';
			markup += '</div>';
			markup += '</div>';
			markup += '</div>';
			markup += '</div>';
			markup += '</div>';
			
			modal = $(modalContainer).html(markup);
			$('.product-modals').append(modal);
			$('#product-content-for-' + product.id ).modal();
			
		});
	
		addToCart();
	
	});

});

/*
 *  Toggle visibility of the off-canvas menu.
 *
 */
function offCanvasToggle() {

	$('.mobile-menu').on('click', function(e) {
		e.preventDefault();
		$('.off-canvas').addClass('in');
	});

	$('.off-canvas-close').on('click', function(e) {
		e.preventDefault();
		$('.off-canvas').removeClass('in');
	});

}

/*
 *  Toggle submenu visibility on mobile navigation.
 *
 */
function submenuToggle() {

	$('.mobile-submenu-toggle').on('click', function(e) {

		e.preventDefault();
		var icon = $(this).find('i');

		$(this).next().slideToggle(200);

		if (icon.hasClass('fa-plus')) {
			icon.removeClass('fa-plus').addClass('fa-minus');
		} else {
			icon.removeClass('fa-minus').addClass('fa-plus');
		}

	});

}

/*
 *  Any scripts that need to be re-invoked should use the shopify:section:load event.
 *
 */
jQuery(document).on('shopify:section:load', function() {

	submenuToggle();
	offCanvasToggle();
	jQuery('.slides').cycle({
		swipe: true
	});
	initCarousels();
	addToCart();
	product();

});

/* Filter Sidebar */

jQuery(document).ready(function() {
	if ($(window).width() < 992) {
		$('.shop-collection-sidebar').hide();
		$('.sidebar-menu').addClass('expanded').hide();
		$('.sidebar-expand').find('.far').removeClass('fa-minus').addClass('fa-plus');
		$('.col_filter_sidebar').click(function() {
			$('.shop-collection-sidebar').toggleClass('active_sidebar').slideToggle();
		});
	}
});


function getHeight() {

	divElement = document.querySelector("header.site-header.d-none.d-xl-block");
	elemHeight = divElement.offsetHeight;
	//   $('main.site-content').css('padding-top',elemHeight);
	// alert(elemHeight);
}

getHeight();
$(document).ready(function() {
	$(window).resize(function() {
		getHeight();
	});
});
/*
var headerheight = jQuery('.site-header').height();
jQuery('.site-breadcrumbs.d-flex.align-items-center').css('margin-top',headerheight);

$( window ).resize(function() {
  var headerheight = jQuery('.site-header').height();
  jQuery('.site-breadcrumbs.d-flex.align-items-center').css('margin-top',headerheight);
});
*/

// New
// $(document).ready(function() {
//   if( typeof(productOptions ) != "undefined" ){
//     for(i=0;i<productOptions.length;i++) {
//       $('.single-option-selector:eq('+ i +')')
//       .filter(function() {
//         return $(this).find('option').length > 1
//       })
//       .prepend('<option value="">Pick a ' + productOptions[i][i] + '</option>')
//       .val('')
//       .trigger('change');
//     }
//   }
// });
$(document).ready(function(){
  $(".product-images .synergy_image_thumb").click(function(){
     $(".product_media_element").show();
  });
  $(".product-featured-images-wrapper .slick-dots li").click(function(){
    $(".product_media_element").show();
  });
  
});

 